import { userIdentification, userIdentificationLabel } from 'shared/constants/user'

export const identificationOptions = [
  userIdentification.FULL,
  userIdentification.FULL_DOSSIER,
].map((item) => ({
  label: userIdentificationLabel[item],
  value: item,
}))
